export default __webpack_public_path__ + "static/pp-baterii-b7e650c85e710be31146771b60d7cfdc.jpg";